import { render } from "./ManagerTemplate.html?vue&type=template&id=31cb0d0d&external"
import script from "./ManagerTemplate.vue?vue&type=script&lang=js"
export * from "./ManagerTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__